import styles from "../Tabelas.module.css";
import Container from "../../../../components/components-ui/Container/Container";
import Button from "../../../../components/components-ui/Button/Button";
import api from "../../../../services/Api";
import { Grid, Col } from "../../../../components/Grid";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function PontosLocaisOrigemAction() {
  const { id } = useParams();
  const [dados, setDados] = useState("");

  function showAlert(notify, msg) {
    if (notify === 0) {
      toast.success(msg, { autoClose: 2500 });
    } else {
      toast.error(msg);
    }
  }

  async function criarOrigem(values) {
    const response = await api.post("/origem/create/", {
      origem: values.origem,
    });
    if (response.data.error === 0) {
      showAlert(0, response.data.msg);
      navigate("/usina/pontoslocaisorigem");
      return;
    }
    showAlert(1, response.data.msg);
  }

  async function editarOrigem(values) {
    const response = await api.put(`/origem/edit/${id}`, {
      origem: values.origem,
    });
    if (response.data.error === 0) {
      showAlert(0, response.data.msg);
      navigate("/usina/pontoslocaisorigem");
      return;
    }
    showAlert(1, response.data.msg);
  }

  useEffect(() => {
    if (id) {
      async function getOrigem() {
        const response = await api.get(`/origem/show/${id}`);
        setDados(response.data);
      }
      getOrigem();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigate = useNavigate();
  const validadtionSchema = Yup.object().shape({
    origem: Yup.string().required("*Campo Obrigatório"),
  });
  return (
    <Container>
      <h3> {id ? "Edição de Origem" : "Cadastro de Origem"}</h3>
      <section className={styles.action_section}>
        <Formik
          initialValues={{
            origem: dados?.origem,
          }}
          enableReinitialize={true}
          onSubmit={
            id
              ? (values) => editarOrigem(values)
              : (values) => criarOrigem(values)
          }
          validationSchema={validadtionSchema}
        >
          {({ errors, touched }) => (
            <Form>
              <Grid>
                <Col size={12}>
                  <label> Nome Origem </label>
                  <Field type="text" name="origem" />
                  {errors.origem && touched.origem ? (
                    <span className={styles.alertError}>{errors.origem}</span>
                  ) : null}
                </Col>
              </Grid>
              <Grid>
                <Col size={12}>
                  <Button type="submit" title={"Salvar"} />
                  <Button
                    type="button"
                    title="Voltar"
                    color="secondary"
                    onClick={() => {
                      navigate("/usina/pontoslocaisorigem");
                    }}
                  />
                </Col>
              </Grid>
            </Form>
          )}
        </Formik>
      </section>
    </Container>
  );
}
